import { render } from "./UpdateSurveyPage.vue?vue&type=template&id=0b2fe127&ts=true"
import script from "./UpdateSurveyPage.vue?vue&type=script&lang=ts"
export * from "./UpdateSurveyPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Dashboard/Surveys/UpdateSurveyPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b2fe127"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b2fe127', __exports__)) {
    api.reload('0b2fe127', __exports__)
  }
  
  module.hot.accept("./UpdateSurveyPage.vue?vue&type=template&id=0b2fe127&ts=true", () => {
    api.rerender('0b2fe127', render)
  })

}


export default __exports__